<template>
  <div>
    <div>
      <div class="flex flex-wrap flex-col m-auto justify-center mt-6 mb-2">
          <span class="block mb-4 text-center text-4xl md:text-6xl font-bold tracking-tight text-gray-700 dark:text-white">Access to Simpleish API</span>
          <span class="block mb-4 text-center text-xl md:text-2xl font-bold tracking-tight text-gray-700 dark:text-white">In order to access our API, only need is just a simple call.</span>
      </div>

      <div class="flex flex-wrap m-auto justify-center">
          <v-card @click="getApiKey" class="pa-5" elevation="0" color="blue lighten-1">
            <h5 style="color: #ffffff;"><strong><i class="fa fa-code"></i></strong></h5>
            <h5 style="color: #ffffff;"><strong>Get your Api Key</strong></h5>
          </v-card>
      </div>
    </div>

    <hr class="mt-10 mb-10">

    <v-row>
      <v-col>
        <span class="block mb-4 text-center text-4xl md:text-6xl font-bold tracking-tight text-gray-700 dark:text-white">Sample Code</span>
        <span class="block mb-4 text-center text-xl md:text-2xl font-bold tracking-tight text-gray-700 dark:text-white">Check out sample code to integrate our API easily.</span>
      </v-col>
    </v-row>

    <SampleCode/>

    <hr class="mt-10 mb-10">

    <v-row>
      <v-col>
        <span class="block mb-4 text-center text-4xl md:text-6xl font-bold tracking-tight text-gray-700 dark:text-white">Output Formats</span>
      </v-col>
    </v-row>

    <v-card class="api-output-format-card" elevation="0">
      <v-row>
        <v-col>
          <div class="row-header">
            <v-row class="api-reference-row">
              <v-col cols="6" class="pa-10">
                <span><strong>Format</strong></span>
              </v-col>
              <v-col cols="6" class="pa-10">
                <span><strong>Resolution</strong></span>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row class="api-reference-row">
        <v-col cols="6" class="pa-10">
          <span><strong>PNG</strong></span>
        </v-col>
        <v-col cols="6" class="pa-10">
          <span><strong>Up to 10 MP</strong></span>
        </v-col>
      </v-row>
      <v-row class="api-reference-row">
        <v-col cols="6" class="pa-10">
          <span><strong>JPG</strong></span>
        </v-col>
        <v-col cols="6" class="pa-10">
          <span><strong>Up to 25 MP</strong></span>
        </v-col>
      </v-row>
    </v-card>

    <br><br>

    <v-row>
      <v-col>
        <span class="block mb-4 text-center text-4xl md:text-6xl font-bold tracking-tight text-gray-700 dark:text-white">API Reference</span>
      </v-col>
    </v-row>
    
    <br>
    
    <v-card class="api-reference-card" elevation="0">
      <v-row class="api-reference-row">
        <v-col cols="6" class="pa-10">
          <span><strong>Server URL: </strong></span><span>https://api.simpleish.com/v1</span>
          <br>
          <span><strong>Method: </strong></span><span>POST</span>
        </v-col>
        <v-col cols="6" class="pa-10">
          <span><strong>Request Body: </strong></span><span>multipart/form-data</span>
          <br>
          <span><strong>API: </strong></span><span>/remove_image_background</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="row-header">
            Authorization
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="pa-10">
          <span><strong>API-KEY</strong></span>
          <br>
          <span>string</span>
        </v-col>
        <v-col cols="6" class="pa-10">
          <span>Your API Key</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="row-header">
            Parameters
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pa-10">
            <span><strong>source_image_file</strong></span>
            <br>
            <span>string($binary)</span>
        </v-col>
        <v-col cols="8" class="pa-10">
          <span>Source image file. Support only PNG, JPG, JPEG.</span>
          <br>
          <span><strong>use only only one source image parameter</strong></span>
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>source_image_url</strong></span>
              <br>
              <span>string</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Source image url. Support only PNG, JPG, JPEG.</span>
            <br>
            <span><strong>use only only one source image parameter</strong></span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>source_image_base64</strong></span>
              <br>
              <span>string</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Source image base64 format. Support only PNG, JPG, JPEG.</span>
            <br>
            <span><strong>use only only one source image parameter</strong></span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>bg_color_code</strong></span>
              <br>
              <span>string</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Output with solid background color. It needs to be a HEX color code. (e.g #EBEBEB, #000000)</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>format</strong></span>
              <br>
              <span>string</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Default value: 'png'. Output image format. Otherwise 'jpg' for JPG format(no transparency) and 'png' for PNG format. PNG format support alpha transparency.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>crop</strong></span>
              <br>
              <span>boolean</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Default value: false. It will cutout all extra transparent pixels and gives cropped image.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>crop_margin</strong></span>
              <br>
              <span>int</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Requirements: crop=True. Default value of this parameter is 0px. It support these values in the following ways</span>
            <br><br>
            <span>Ex. 10px - create margin all around the subject.</span>
            <br>
            <span>Ex. 15% - create margin all around the subject with respect to the subject size.</span>
            <br>
            <span>Ex. 5px,10px - create 5px margin left and right side, 10px margin top and bottom size.</span>
            <br>
            <span>Ex. 5%, 10% - create 5% margin left and right side, 20% margin top and bottom side with respect to the subject size.</span>
            <br>
            <span>Ex. 5px, 10px, 15px, 20px - create 5px margin left, 10px margin top, 15px margin right, 20px margin bottom</span>
            <br>
            <span>Ex. 5%, 10%, 15%, 20% - create 5% margin left, 10% margin top, 15% margin right, 20% margin bottom with respect to the subject.</span>
            <br>
            <span>crop_margin parameter support max 500px or max 50% of the subject size.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>scale</strong></span>
              <br>
              <span>string</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>This parameter scales the subjectin the output image. Can be any range between 10% or 100% depending on the image dimensions. Default position parameter value is 'center', unless any other position parameter is given.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>position</strong></span>
              <br>
              <span>string</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>This parameter places the subject within the canvas. Only works when 'scale' parameter is given. Default parameter value is 'center'. Can be a single value between 0% to 100%(horizontal and vertical) or two values between 0% and 100% separated by comma (eg: 10%,20%) both horizontal and vertical.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>preview</strong></span>
              <br>
              <span>boolean</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Default value: false. If true it will resize image 0.25 megapixel. (e.g 400x600 pixels) 0.25 credit will be charged per preview image. 1 credit will be charged if value set to false.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>channel</strong></span>
              <br>
              <span>boolean</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>This parameter returns the image channel(red, green, blue, alpha) in RGBA or alpha mask format. 'rgba' is the default parameter, returns alpha mask if value is set to 'alpha.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>roi</strong></span>
              <br>
              <span>string</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>This parameter when given will let you extract the region of interest of a particular bounding box, only the contents of the selected rectangular will be consider as a foreground and everything else will be consider as background and will be completely removed.</span>
            <br><br>
            <span>Ex. 100px,200px,150px,300px - left,top,right,bottom coordinates</span>
            <br>
            <span>Ex. 10%,20%,15%,30% - left,top,right,bottom with respect to the image size.</span>
          </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="row-header">
            Response
          </div>
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>Code: 200</strong></span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Successfully removed image background.</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>Code: 400</strong></span>
              <br>
              <span>error</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Invalid parameters or unable to process input image file(<i>no credit taken</i>)</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>Code: 401</strong></span>
              <br>
              <span>error</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>API-KEY missing or invalid API-KEY(<i>no credit taken</i>)</span>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>Code: 402</strong></span>
              <br>
              <span>error</span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>No credits remaining(<i>no credit taken</i>)</span>
          </v-col>
      </v-row>
    </v-card>

    <br><br>

    <v-row>
      <v-col>
        <span class="block mb-4 text-center text-4xl md:text-6xl font-bold tracking-tight text-gray-700 dark:text-white">Credit API Reference</span>
      </v-col>
    </v-row>

    <br>

    <v-card class="api-reference-card" elevation="0">
      <v-row>
        <v-col cols="6" class="pa-10">
          <span><strong>Server URL: </strong></span><span>https://api.simpleish.com/v1</span>
          <br>
          <span><strong>Method: </strong></span><span>POST</span>
        </v-col>
        <v-col cols="6" class="pa-10">
          <span><strong>Request Body: </strong></span><span>multipart/form-data</span>
          <br>
          <span><strong>API: </strong></span><span>/credit</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="row-header">
            Authorization
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="pa-10">
          <span><strong>API-KEY</strong></span>
          <br>
          <span>string</span>
        </v-col>
        <v-col cols="6" class="pa-10">
          <span>Your API Key</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="row-header">
            Response
          </div>
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="4" class="pa-10">
              <span><strong>Code: 200</strong></span>
          </v-col>
          <v-col cols="8" class="pa-10">
            <span>Successfully fetched credit details.</span>
          </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import SampleCode from '@/components/User/SampleCode.vue'

  export default {
    name: 'ApiDocumentation',

    components: {
      SampleCode
    },

    data(){
      return {
        datahtml: ''
      }
    },

    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      }
    },

    created(){
      this.base = 'http://localhost:8000';
    },

    methods: {
      getApiKey() {
        if(this.loggedIn)
        {
          this.$router.push('/client-details');
        }else{
          this.$router.push('/login');
        }
      }
    }
  }
</script>

<style scoped>
.api-reference-card{
  font-size:16px;
  font-weight: 500;
  text-align: start;
  border: 1px solid #ebebeb;
}

.api-reference-card .row-header{
  font-size: 20px;
  font-weight: bold;
  background-color:rgb(168, 255, 194);
  padding: 10px 20px;
}

.api-reference-card .orange{
  background-color:darkorange;
}


.api-output-format-card{
  font-size:16px;
  text-align: start;
  border: 1px solid #ebebeb;
}

.api-output-format-card .row-header{
  font-size: 20px;
  font-weight: bold;
  background-color:rgb(168, 255, 194);
  padding: 10px 20px;
}

</style>